import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import SearchFilter from "../../../Templates/SearchFilter"
import { SORT, toggleSorting } from "../../../Templates/functions"
import { renderSortingIcon } from "../../../Templates/functions";
import { WIListSkeleton } from '../../../Templates/icons'
import FormRow from '../../../Templates/FormRow'
import Checkbox from '@material-ui/core/Checkbox';
class WIAssignments extends Component {

    state = {
        displayBanner: false,
        confirmationMessage: "",
        openModal: false,
        pendingAdditions: [],
        pendingRemovals: [],
        sortingByUsername: 0,
        sortingByRole: 0,
        filteredUsers: [],
        filteringUsers: false,
    }

    filterUsersList = (searchText) => {
        if (searchText === "") {
            this.setState({
                filteredUsers: [],
                filteringUsers: false,
            });
        } else {
            const usersArray = Object.values(this.props.users);
            const filteredUsers = usersArray.filter(user => user.username.toLowerCase().includes(searchText));
            this.setState({
                filteredUsers,
                filteringUsers: true,
            });
        }
    }
    

    confirmPendingAssignments = () => {
        let assignments = {
            pendingAdditions: this.state.pendingAdditions,
            pendingRemovals: this.state.pendingRemovals
        }

        this.props.assignUsers(assignments, this.props.selectedWIID).then(() => {
          this.props.updateUserAssignment(this.props.selectedWIID)
        })
        .catch((e)=>{
            alert("There was an error updating the assignments")
            console.log(e)

        })
        
        this.props.openConfirmation()
    }


    selectUser = (index, userId) => {

        // We know that a user was originally assigned via (this.state.assignedUserIDs)
        //Rules for checkboxes:
            // If a user was originally Assigned it should never go into pending addition array (for the duration of this component)
            // similarly if a user was not previously assigned then it should never be put into pending removal array.
            // ex. user A was already assigned so his checkbox will be 'checked' by default. If that user is selected it will be put into
            // pendingRemovals array. If it is selected again, it will be filtered out of pending removal array.
        let pendingAdditions = this.state.pendingAdditions
        let pendingRemovals = this.state.pendingRemovals

        if (!this.props.assignedUsersIDs[userId]) {
            if (!pendingAdditions.some(pendingAddition => pendingAddition[1] === userId)) {
                pendingAdditions.push([index, userId])
            } else {
                pendingAdditions = pendingAdditions.filter(pendingAddition => pendingAddition[1] !== userId)
            }
        } else {
            if (!pendingRemovals.some(pendingRemoval => pendingRemoval[1] === userId)) {
                pendingRemovals.push([index, userId])
            } else {
                pendingRemovals = pendingRemovals.filter(pendingRemoval => pendingRemoval[1] !== userId)
            }
        }

        this.setState({
            pendingAdditions,
            pendingRemovals
        })
    }

    renderUsersList = () => {
        if (this.props.loading) {
            return WIListSkeleton
        } else {
            let usersList
            let filteredUsers = this.state.filteredUsers
        
            if (this.state.filteringUsers) {
                usersList = filteredUsers
            } else {
                usersList = Object.values(this.props.users) || []
            }

            if (this.state.sortingByUsername) {
                usersList = SORT(this.state.sortingByUsername, usersList, "username")
            }

            if (usersList.length > 0) {
                let ids = []
                let isSelected={}
                let rowData = usersList.map(user => {
                    let selectedState = (this.props.assignedUsersIDs[user._id] && !this.state.pendingRemovals.some(pendingObject => pendingObject[1] === user._id)) || (!this.props.assignedUsersIDs[user._id] && this.state.pendingAdditions.some(pendingObject => pendingObject[1] === user._id))
                    isSelected[user.username] = selectedState
                    let data = []
                    data.push(<Checkbox
                        checked={selectedState}
                        color="primary"
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                    />)
                    data.push(user.username)
                    data.push(user.role)
                    ids.push(user._id)
                    return data
                })
                return <Fragment>
                    <FormRow
                        isHeader={true}
                        rowData={["", "User Name", "User Role"]}
                        callbacks={[() => null, () => toggleSorting(this.state.sortingByUsername,
                            (value) => this.setState({
                                sortingByUsername: value,
                            }), () => null
                        )]}
                        states={[null, this.state.sortingByUsername, null]}
                        widths={["10%", "45%", "45%"]}
                    />
                    <div id="rows-container">
                        {rowData.map((row, index) => {
                            return <FormRow
                                rowData={row}
                                widths={["10%", "45%", "45%"]}
                                selectRow={() => this.selectUser(index, ids[index])}
                                isSelected={isSelected[row[1]]}
                                centeredIndices={[]}
                            />
                        })}
                    </div>
                </Fragment>
            } else {
                return <div id="assignment-list-item" className="no-hover">
                    <div id="management-user-list-item-info" className="flex-column">There are no assignable users</div>
                </div>
            }
        }
    }

    render () {
        return <div id="wi-page-content-container" className="flex-column shadow">
            <div id="wi-page-container-header">
                <h3 className="break-word">Manage Assignees</h3>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginRight: "1em" ,width:"94%"}}>
                <SearchFilter filterList={this.filterUsersList} />
                <div className="flex" style={{ width: "1em", justifyContent: "space-between", alignItems: "center", color: "#777777" }}>
                    <div onClick={() => toggleSorting(this.state.sortingByTitle, (value) => this.setState({ sortingByTitle: value }))}>
                        {renderSortingIcon("text", this.state.sortingByTitle)}
                    </div>
                </div>
            </div>
            <ul id="wi-page-user-list" className="overflow">
                {this.renderUsersList()}
            </ul>
            <div className="flex-centered">
                <div className="assignments-button clickable" style={{ margin: ".5em" }} onClick={this.confirmPendingAssignments}>
                    <p style={{ color: "#f3f3f3" }}>Confirm</p>
                </div>
                <div className="assignments-button clickable" style={{ background: "#f3f3f3", margin: ".5em" }} onClick={this.props.cancel}>
                    <p>Cancel</p>
                </div>
            </div>
        </div>
    }
}
        
export default withRouter(WIAssignments)